import { Alert } from "@mui/material";

export default function StatusAlerts({ alerts }) {
  const styles = {
    alert: { m: 2 },
  };

  return (
    <>
      {alerts
        .filter(({ message }) => message)
        .map(({ message, severity }, index) => (
          <Alert key={index} severity={severity} sx={styles.alert}>
            {message}
          </Alert>
        ))}
    </>
  );
}
